import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { closeEditAgency } from 'reducers/DialogsReducer';
import Dialog from 'components/Dialog';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { handleError } from 'reducers/ErrorReducer';
import AgencyTab from 'Dialogs/Agencies/AddAgency/AgencyTab';
import AgencyContact from './AgencyContact';
import AgencyEmployees from './AgencyEmployees';
import AgencyVehicles from './AgencyVehicles';
import AgencyAddresses from './AgencyAddresses';
import AgencySettings from './AgencySettings';
import AgencyCad from './AgencyCad';
import AgencyRms from './AgencyRms';
import AgencyMobile from './AgencyMobile';

const useStyles = makeStyles(theme => ({
  wrap: {
    padding: theme.spacing(3),
  },
  content: {
    margin: -theme.spacing(3),
  },
}));

function EditAgency(props) {
  const classes = useStyles();
  const { AgencyID, mode, Description, websocket } = props;
  const [tab, setTab] = useState('edit'); // edit
  const [agencyPlaceDepartmentId, setAgencyPlaceDepartmentId] = useState(null);
  const mountedRef = useRef(true);
  const newAddress = !AgencyID;

  const [accessControl, setAccessControl] = useState({
    settings: true,
    cad: true,
    rms: true,
    mobile: true,
  });

  useEffect(() => {
    if (!websocket) return;

    const modules = ['Settings', 'CAD', 'RMS', 'Mobile'];
    const cdrService = websocket.service('cdr');

    Promise.all(
      modules.map(module =>
        cdrService
          .get({ Path: `Settings.Application.${module}`, CDRKey: 'AccessControl' })
          .then(data => {
            const item = data?.[0];
            return {
              module: module.toLowerCase(),
              value: !item || item.ValueBoolean == null ? true : Boolean(item.ValueBoolean),
            };
          })
          .catch(() => ({ module: module.toLowerCase(), value: true }))
      )
    ).then(results => {
      if (!mountedRef.current) return;
      const newAccessControl = {};
      results.forEach(({ module, value }) => {
        newAccessControl[module] = value;
      });
      setAccessControl(newAccessControl);
    });
  }, [websocket]);

  useEffect(() => {
    if (props.tab) setTab(props.tab);

    return () => {
      mountedRef.current = false;
    };
    // eslint-disable-next-line
  }, [props.tab]);

  // If current tab becomes hidden, fall back to 'edit'
  useEffect(() => {
    if (!accessControl[tab]) setTab('edit');
  }, [accessControl, tab]);

  const close = data => {
    props.closeEditAgency(data);
  };

  const renderAgencyTab = () => {
    return (
      <div className={classes.wrap}>
        <AgencyTab
          agencyId={AgencyID}
          close={close}
          mode={mode}
          setAgencyPlaceDepartmentId={setAgencyPlaceDepartmentId}
        />
      </div>
    );
  };
  return (
    <Dialog
      toolbar
      onClose={close}
      title={newAddress ? 'Add Agency' : `Edit ${AgencyID}  : ${Description || ''}`}
      fullScreen>
      <div className={classes.content}>
        {mode === 'add' && renderAgencyTab()}
        {mode === 'edit' && (
          <>
            <Paper square>
              <Tabs variant="scrollable" value={tab} onChange={(ev, val) => setTab(val)}>
                <Tab label="Edit Agency" value="edit" />
                <Tab label="Address" value="address" />
                <Tab label="Contact" value="contact" />
                <Tab label="Employees" value="employees" />
                <Tab label="Vehicle Registrations" value="vehicles" />
                {accessControl.settings && <Tab label="Settings" value="settings" />}
                {accessControl.cad && <Tab label="CAD" value="cad" />}
                {accessControl.rms && <Tab label="RMS" value="rms" />}
                {accessControl.mobile && <Tab label="Mobile" value="mobile" />}
              </Tabs>
            </Paper>
            {tab === 'edit' && renderAgencyTab()}
            {tab === 'address' && <AgencyAddresses agencyId={AgencyID} />}
            {tab === 'contact' && <AgencyContact agencyId={AgencyID} />}
            {tab === 'employees' && <AgencyEmployees agencyId={AgencyID} />}
            {tab === 'vehicles' && <AgencyVehicles agencyId={AgencyID} />}
            {tab === 'settings' && accessControl.settings && <AgencySettings agencyId={AgencyID} />}
            {tab === 'cad' && accessControl.cad && (
              <AgencyCad agencyId={AgencyID} placeDepartmentId={agencyPlaceDepartmentId} />
            )}
            {tab === 'rms' && accessControl.rms && <AgencyRms agencyId={AgencyID} />}
            {tab === 'mobile' && accessControl.mobile && <AgencyMobile agencyId={AgencyID} />}
          </>
        )}
      </div>
    </Dialog>
  );
}

const mapStateToProps = state => ({
  websocket: state.websocket.websocket,
});

export default connect(mapStateToProps, {
  closeEditAgency,
  handleError,
})(EditAgency);
